import { useEffect, useState } from "react";
import axios from "axios";
import { ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STYLE_BG = {
  info: "bg-[var(--blue-deep)] text-white",
  urgent: "bg-red-700 text-white",
  celebration: "bg-[var(--honey)] text-[var(--blue-ink)]",
};

export default function AnnouncementBanner() {
  const [ann, setAnn] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/announcements/active`)
      .then((r) => setAnn(r.data || null))
      .catch(() => setAnn(null));
  }, []);

  if (!ann || dismissed) return null;

  const cls = STYLE_BG[ann.style] || STYLE_BG.info;

  return (
    <div
      className={`w-full ${cls} text-center text-sm font-medium py-2.5 px-4`}
      role="status"
      data-testid="site-announcement"
    >
      <div className="max-w-5xl mx-auto flex flex-wrap items-center justify-center gap-3">
        <span>{ann.message}</span>
        {ann.link_url && ann.link_label && (
          <a
            href={ann.link_url}
            target={ann.link_url.startsWith("http") ? "_blank" : "_self"}
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 underline underline-offset-2 hover:no-underline"
          >
            {ann.link_label} <ArrowUpRight className="w-3.5 h-3.5" />
          </a>
        )}
        <button
          onClick={() => setDismissed(true)}
          aria-label="Dismiss announcement"
          className="ml-2 opacity-75 hover:opacity-100 text-lg leading-none"
        >
          ×
        </button>
      </div>
    </div>
  );
}
